// menu-data.ts
export interface MenuItem {
  title: string;
  icon: string;
  link: string;
  subItems?: MenuItem[];
}

export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'Board',
    icon: 'space_dashboard',  // Changed from 'dashboard'
    link: '/boards/list'
  },
  {
    title: 'Timesheet',
    icon: 'schedule',
    link: '/timesheet'
  },
  {
    title: 'Leaderboard',
    icon: 'leaderboard',
    link: '/leaderboard'
  },
  {
    title: 'Files',
    icon: 'folder',  // Try the base icon first with material-icons-outlined class
    // or try one of these alternatives:
    // icon: 'folder_open',
    // icon: 'drive_folder_upload',
    // icon: 'folder_shared',
    link: '/files'
  },
  {
    title: 'Admin',
    icon: 'settings',
    link: '/settings',
    subItems: [
      {
        title: 'User',
        link: '/users',
        icon: 'person_outline'  // Changed from 'person'
      },
      {
        title: 'Client',
        link: '/clients',
        icon: 'business'
      },
      {
        title: 'Project',
        link: '/project',
        icon: 'assignment'  // Changed from 'assignment_outline' to 'assignment'
      },
      {
        title: 'Reports',
        icon: 'assessment',
        link: '/reports-dashboard'
      },
      {
        title: 'Billing',
        icon: 'payment',
        link: '/billing'
      },
      {
        title: 'Integrations',
        icon: 'extension',
        link: '/integrations'
      }
    ]
  },
];